import type { ReactNode } from 'react';

/**
 * Numero de destaque (stat tile). A variacao e opcional e sempre vem com seta
 * e sinal, nunca so com cor.
 *
 * No celular as faixas de indicadores tem 2 colunas; o ultimo, se sobrar
 * sozinho, ocupa a linha inteira em vez de deixar uma celula vazia.
 */
export function Indicador({
  rotulo,
  valor,
  complemento,
  variacao,
}: {
  rotulo: string;
  valor: ReactNode;
  complemento?: ReactNode;
  variacao?: { texto: string; direcao: 'sobe' | 'desce' | 'igual' } | null;
}) {
  return (
    <div className="min-w-0 border-l-2 border-destaque bg-superficie px-4 py-3 max-sm:odd:last:col-span-2">
      <p className="rotulo-secao leading-tight">{rotulo}</p>
      <p className="numero mt-1 text-2xl font-semibold tracking-tight text-marca">{valor}</p>
      {(complemento || variacao) && (
        <p className="numero mt-0.5 text-xs leading-snug text-apagado">
          {variacao && (
            <span className="mr-1.5 font-medium text-texto">
              {variacao.direcao === 'sobe' ? '▲' : variacao.direcao === 'desce' ? '▼' : '='} {variacao.texto}
            </span>
          )}
          {complemento}
        </p>
      )}
    </div>
  );
}
